import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, ActivatedRoute } from '@angular/router';
import { EmployeeProfileApi } from '../api.gen';
import { LoaderService } from '../loader.service';

@Injectable({
  providedIn: 'root'
})
export class EmpAdditionalDocUploadGuard  {
  constructor(private empApi: EmployeeProfileApi, private router: Router, private loader: LoaderService,) { }

  public additionalFileUploadAsPromise(id): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.empApi.additionalDocUploadPageStatus(id).subscribe(resp => resolve(resp), err => reject(false));
    });
  }
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    var id = next.paramMap.get('id');
    this.loader.show();
    const authenticated = await this.additionalFileUploadAsPromise(id);
    this.loader.clear();
    if (!authenticated) {
      this.router.navigate(['/denied']);
    }
    return authenticated;
  }
}
